"use client";

import { GripVertical } from "lucide-react";
import { HTMLAttributes } from "react";

interface DragHandleProps extends HTMLAttributes<HTMLButtonElement> {
  size?: "sm" | "md" | "lg";
  visible?: boolean;
}

const sizeStyles: Record<"sm" | "md" | "lg", { button: string; icon: number }> = {
  sm: { button: "w-5 h-5", icon: 12 },
  md: { button: "w-6 h-6", icon: 14 },
  lg: { button: "w-7 h-7", icon: 16 },
};

export function DragHandle({
  size = "md",
  visible = true,
  className = "",
  ...props
}: DragHandleProps) {
  const sizeStyle = sizeStyles[size];

  return (
    <button
      type="button"
      className={`
        flex items-center justify-center rounded cursor-grab
        text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100
        transition-all duration-150
        ${sizeStyle.button}
        ${visible ? "opacity-100" : "opacity-0"}
        ${className}
      `}
      {...props}
    >
      <GripVertical width={sizeStyle.icon} height={sizeStyle.icon} />
    </button>
  );
}

export { type DragHandleProps };
